import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SetLoginTokenInterceptor } from './set-login-token.interceptor';

export const interceptorProviders = [{ provide: HTTP_INTERCEPTORS, useClass: SetLoginTokenInterceptor, multi: true }];